export const en = {
    icon: {
        'SME': 'mdi-factory',
        'MIKRO': 'mdi-account-group'
    },
    msg: {
        // login
        'login': 'Login',
        'username_error_max': 'Please enter your username.',
        'username_error_regex': 'Please enter your username.',
        'password_error_max': 'Please enter your password.',
        'password_error_regex': 'Please enter your password.',
        'error': 'Invalid username or password',
        'blank_username_field': 'Please enter your username.',
        'blank_password_field': 'Please enter your password.',
        'password_error_confirmed': 'Password does not match with new Password.',
        'invalid_credentials': 'Please enter a valid username or password.',
        'copyright': 'Powered by Global Psytech',
        'username_label': 'Username',
        'password_label': 'Password',
        'new_password_label': 'New Password',
        'new_confirm_password_label': 'New Confirm Password',
        'id_number_label': 'ID Number',
        'serverError': 'Sorry, something went wrong. Please try again.',
        'footer_text': 'Global Psytech Sdn. Bhd.',
        'login_button': 'Login',

        // Results Page
        'assessmentDropdownLabel': 'Assessment',
        'sessionDropdownLabel': 'Session',
        'divisionDropdownLabel': 'Division',
        'departmentDropdown': 'Department',
        'registered_employees_text': 'Registered Employees',
        'finished_employees_text': 'Finished',
        'results_page_heading_name': 'Results',
        'filters': 'Filters',
        'table_heading': 'List of Individual Test Report',
        'search': 'Search',
        // Table Headers (Results Page)
        'table_header_name': 'Name',
        'table_header_employeeId': 'Employee Id',
        'table_header_assessment_name': 'Assessment Name',
        'table_header_assessment_session': 'Session',
        'table_header_report': 'Report',
        'table_header_division': 'Division',
        'table_header_department': 'Department',
        'table_header_unit': 'Unit',
        'table_header_option': 'Options',
        'search_placeholder': 'Search',
        // Header
        'logout': 'Logout',
        // SideBar
        'sidebar_text_dashboard': 'Dashboard',
        'sidebar_text_results': 'Results',
        // Loader
        'loading': 'Loading',
        // Table Headers (Growth Profile Page)
        'table_header_gp_date': 'Date',
        'table_header_gp_assessment_name': 'Assessment Name',
        'table_header_gp_programme_name': 'Programme Name',
        'table_header_gp_assessment_session': 'Session',
        'table_header_gp_status': 'Status',
        'table_header_gp_report': 'Reports',
        // Registration error
        'full name (as per nric)_error_required': 'Please enter customers full name as indicated on NRIC.',
        'full name (as per nric)_error_regex': 'Only acceptable characters include letters of the alphabet and special characters such as @ ‘ / - .',
        'full name (as per nric)_error_max': 'The name cannot be longer than 80 characters.',
        'identification number (id)_error_alpha_num': 'The only acceptable characters are letters of the alphabet and numerals.',
        'identification number (id)_error_required': 'Please enter NRIC/ passport number.',
        'application id_error_required': 'Please enter customers application ID.',
        'application id_error_max': 'The application ID must not be longer than 15 characters.',
        'application id_error_alpha_num': 'The only acceptable characters are letters of the alphabet and numerals.',
        'business registration (br) no_error_required': 'Please enter company’s BR number.',
        'business registration (br) no_error_max': 'The BR number must not be longer than 15 characters.',
        'business registration (br) no_error_alpha_num': 'The only acceptable characters are letters of the alphabet and numerals.',
        'company name_error_required': 'Please enter company’s name.',
        'company name_error_max': 'The company name must not be longer than 80 characters.',
        'company name_error_regex': 'The only acceptable characters are letters of the alphabet, spaces, numerals, and the following special characters: . - & () and ’',
        'business category_error_required': 'Please select company’s business categories.',
        'financing amount requested (rm)_error_required': 'Please enter financing amount.',
        'financing amount requested (rm)_error_numeric': 'This entry can only contain numbers.',
        'financing tenure_error_required': 'Please enter financing tenure.',
        'financing tenure_error_min_value': 'The tenure amount requested must be at least 10.',
        'financing tenure_error_max_value': 'The tenure amount must not exceed 120.',
        'programme applied_error_required': 'Please select programme applied.',
        'facility applied_error_required': 'Please select facility applied.',
        'region_error_required': 'Please select region.',
        'orr_error_required': 'Please enter ORR.',
        'orr_error_numeric': 'The only acceptable characters are letters of the alphabet and numerals.',
        'financing amount_error_required': 'Please enter financing amount.',
        'financing amount_error_numeric': 'This entry can only contain numbers.',
        'email_error_required': 'Please enter email address.',
        'email_error_email': 'Please enter a valid email address.',
        'sms_error_required': 'Please Enter Mobile Number',
        'sms_error_numeric': 'Please enter a valid Mobile Number',
        'scheme_error_required': 'Please select the scheme you are applying.',
        'branch_error_required': 'Please select a CGC branch that you are dealing with.',
        'business_registration_number_error_required': 'Please enter your company’s BR number.',
        'businesscategory_error_required': 'Please select Business Category',
        'typeofbusiness_error_required': 'Please select type of Business',
        'customerapplicationstatus_error_required': "Please select application status",
        'financingamountapproved_error_required': 'Specify amount',
        'tenureapproved_error_required': 'Specify a number',
        'financingamountapproved_error_min_value':'The minimum amount should be greater than 0',
        'financingamountapproved_error_max_value':'The maximum amount should not be greater than 999999999',
        'financingamountapproved_error_numeric': 'Only numeric values are accepted',
        'tenureapproved_error_min_value':'The minimum value should be greater than 0',
        'tenureapproved_error_max_value':'The maximum value should not be greater than 180',
        'tenureapproved_error_numeric': 'Numeric values only',

        'otherEthnicity_error_required': 'Please provide customers ethnicity',
        'companyName_error_required': 'Please enter company name',
        'officerName_error_required': 'Please enter officer name',
        'officerId_error_required': 'Please enter officer id',
        'financingAmount_error_required': 'Please enter financing amount',
        'tenureApplied_error_required': 'Please enter tenure applied',
        'businessCategory_error_required': 'Please select business category',
        'gender_error_required': 'Select gender',
        'ethnicity_error_required': 'Please select gender',
        'employeesCount_error_required': 'Please enter number of employees',
        'annualSales_error_required': 'Please enter annual sales',
        'annualProfit_error_required': 'Please enter annual profit',
        'applicationNumber_error_required': 'Please enter application number',
        'financingAmountApproved_error_required': 'Please enter financing amount',
        'financingAmountApproved_error_max_value': 'The maximum entry is 999999999.',
        'financingAmountApproved_error_min_value': 'The minimum entry is 0.',
        'tenureApproved_error_required': 'Please enter tenure approved',
        'tenureApproved_error_max_value': 'The maximum entry is 999999999.',
        'tenureApproved_error_min_value': 'The minimum entry is 0.',
        'employeesCount_error_numeric': 'Only numbers are allowed.',
        'annualSales_error_numeric': 'Only numbers are allowed.',
        'annualProfit_error_numeric': 'Only numbers are allowed.',
        'officerId_error_numeric': 'Only numbers are allowed.',
        'officerId_error_min': 'The ID must be at least 4 characters long.',
        'officerId_error_max': 'The ID number cannot be longer than 6 characters.',
        'officerName_error_regex': 'Only alphabet, spaces, and the following special characters: @ ’ - and / are accepted',
        'officerName_error_min': 'The name must be at least 5 characters long.',
        'officerName_error_max': 'The name cannot be longer than 80 characters.',
        'companyName_error_min': 'The company name must be at least 5 characters long.',
        'companyName_error_regex': 'Only alphabet, spaces, numerals, and the following special characters: . - & () and ’ are accepted',
        'companyName_error_max': 'The company name must not be longer than 80 characters.',
        'fullName_error_min': 'The name must be at least 5 characters long.',
        'fullName_error_regex': 'Only letters of the alphabet, spaces, and the following special characters: @ ’ - and / are accepted',
        'fullName_error_max': 'The name cannot be longer than 80 characters.',
        'applicationNumber_error_numeric': 'Only numbers are allowed.',
        'applicationNumber_error_alpha_num': 'Only alphabets and numbers are accepted',
        'financingAmountApproved_error_numeric': 'Only numbers are allowed.',
        'tenureApproved_error_numeric': 'Only numbers are allowed.',
        'tenureApplied_error_numeric': 'Only numbers are allowed.',
        'employeesCount_error_min_value': 'The minimum entry is 0.',
        'employeesCount_error_max_value': 'The maximum entry is 999999999.',
        'annualSales_error_max_value': 'The maximum entry is 999999999.',
        'annualSales_error_min_value': 'The minimum entry is 0.',
        'annualProfit_error_max_value': 'The maximum entry is 999999999.',
        'annualProfit_error_min_value': 'The minimum entry is 0.',

        // Login
        'username_error_required': 'Please enter your username',
        'password_error_required': 'Please enter your password',

        // Dashboard
        'export_button': 'Export',

        // Headers
        'sl_no': 'No.',
        'verification_code': 'Verification Code',
        'br_number': 'Business Registration (BR)No.',
        'company_name': 'Company Name',
        'id_number': 'Identification Number (ID)',
        'business_category': 'Business Category',
        'staff_id_number': 'Staff ID No.',
        'branch': 'Branch',
        'scheme': 'Scheme',
        'financing_amount_requested': 'Financing Amount Requested (RM)',
        'tenure_applied': 'Tenure Applied',
        'gfi_status': 'GFI Status',
        'gfi_completion_date': 'GFI Completion Date',
        'update_details': 'Update Details',
        'gfi_scoring': 'GFI Scoring',
        'application_status': 'Application Status',
        'report': 'Report',
        'expiry_date': 'Expiry Date',
        'f1': 'F1',
        'f2': 'F2',
        'f3': 'F3',
        'gfi_rating': 'GFI Rating',

        // Dropdowns
        'scheme_label': 'Scheme',
        'amount_range_label': 'Financing Amount Range',
        'gfi_status_label': 'GFI Status',
        'financing_application_status_label': 'Financing Application Status',
        'start_date_label': 'Start Date',
        'end_date_label': 'End Date',
        'branch_label': 'Branch',
        'report_unavailable': 'Please wait while the report is being generated.<br>If the problem persists please contact support',
        'export_unavailable': 'We encountered an error while exporting data , please try again.<br>If the problem persists please contact support',
        'close_label': 'Close',
        'customerApplicationStatus_error_required': 'Please select the application status',

        // TimeOut Dialog
        'session_expire_heading': 'Session Expiration Warning',
        'session_expire_message_1': 'Your session will expire in',
        'session_expire_message_2': 'seconds. Please click “Continue” to continue your session or click “Log Out Now” to end your session now.',

        'table_heading_export': 'Data Export History',
        'table_header_no': 'Sl No.',
        'table_header_date': 'Export Date',
        'table_header_finance_type': 'Finance Type',
        'table_header_filter_applied': 'Filters Applied',
        'table_header_status': 'Status',
        'table_header_download': 'Download',


        'date_error_required':'Select a date',
        'malaysianowned_error_required':'Select an option',
        'paidupcapital_error_numeric': 'Numeric value only',
        'paidupcapital_error_min_value': 'The minimum amount should be greater than 0',
        'paidupcapital_error_max_value': 'The maximum amount should not be greater than 999999999',
        'businesssize_error_required':'Select an option',
        'natureofbusiness_error_required':'Select an option',
        'industryexperience_error_required':'Specify a number',
        'industryexperience_error_min_value':'The minimum value should be greater than 0',
        'industryexperience_error_max_value':'The maximum value should be greater than 180',
        'industryexperience_error_numeric': 'Numeric values only',
        'employeescount_error_required':'Specify a number',
        'employeescount_error_numeric': 'Numeric values only',
        'employeescount_error_min_value':'The minimum value should be greater than 0',
        'employeescount_error_max_value':'The maximum value should be greater than 1000',
        'annualsales_error_integer':'Please enter a valid amount',
        'annualsales_error_required':'Specify amount',
        'annualsales_error_min_value':'The minimum amount should be greater than -999999999',
        'annualsales_error_max_value':'The maximum amount should not be greater than 999999999',
        'annualsales_error_numeric': 'Numeric values only',
        'annualprofit_error_integer':'Please enter a valid amount',
        'annualprofit_error_required':'Specify amount',
        'annualprofit_error_min_value':'The minimum amount should be greater than -999999999',
        'annualprofit_error_max_value':'The maximum amount should not be greater than Annual Sales Turnover.',
        'annualprofit_error_numeric': 'Numeric values only',
        'financingamount_error_required':'Specify amount',
        'financingamount_error_min_value':'The minimum amount should be greater than 0',
        'financingamount_error_max_value':'The maximum amount should not be greater than 999999999',
        'financingamount_error_numeric': 'Numeric values only',
        'tenureapplied_error_required':'Specify a number',
        'tenureapplied_error_min_value':'The minimum value should be greater than 0',
        'tenureapplied_error_max_value':'The maximum value should not be greater than 180',
        'tenureapplied_error_numeric': 'Numeric values only',
        'ctosrating_error_max': 'Cannot be more than 100 characters',
        'ctosrating_error_numeric': 'Numeric values only',
        'ctosrating_error_min_value': 'The minimum value should be greater than 300',
        'ctosrating_error_max_value': 'The maximum value should not be greater than 850',
        'cbrrating_error_regex':'Numeric and Decimal values only',
        'applicationnumber_error_alpha_num':'Alphabets and Numbers only',
        'applicationnumber_error_max':'The maximum value should not be greater than 20'
    }
}
